import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import BudgetingLayer from "../components/BudgetingLayer";

const BudgetingPage = () => {
  return (
    <>
      <MasterLayout pageTitle="Budgeting">
        <BudgetingLayer />
      </MasterLayout>
    </>
  );
};

export default BudgetingPage;
